import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';
import TextInput from '../../../../../components/TextInput';
import HardwareResults from './HardwareResults';
import { push } from 'connected-react-router';
import { actions, selectors } from '../../../../../../modules/customer/profile/hardwareProducts';
import { isBoxSerialValidOrEmpty, isBoxSerialValid } from '../../../../../../common/validation';
import { selectors as ui } from '../../../../../../modules/ui';

const BoxInput = ({ addBoxForm, setHardwareSerial, getHardwareBySerial }) => {
    const { serialNumber, isValid, isLoading, notEligibleToMove, list } = addBoxForm;

    const onSerialInputChange = ({ target: { value: serial } }) => {
        setHardwareSerial(serial);
        if (isBoxSerialValid(serial)) {
            getHardwareBySerial(serial);
        }
    }

   const onSerialInputKeyPress = (e) => {
        if (!(ui.isNumericKeyPress(e) || ui.isCtrlCKeyPress(e) || ui.isCtrlVKeyPress(e))) {
          e.preventDefault();
        }
    }

    return (
        <div className="wrapper box">
            <div className="image box"></div>
            <div className="info-text">
                Serienummer finner du printer undersiden av mottakere eller på baksiden for CAM/kortmodul
            </div>
            <TextInput
                value={serialNumber}
                onChange={onSerialInputChange}
                onKeyPress={onSerialInputKeyPress}
                isValid={isValid}
                placeholder="Serienummer - 16 siffer"
                containerClass="number-input"
                errorMessage="Ugyldig serienummer"
            />
            {isBoxSerialValid(serialNumber) &&
                <HardwareResults productData={addBoxForm}
                    titleText='Mottaker Funnet'
                />
            }
        </div>
    );
}


const mapStateToProps = createStructuredSelector({
    addBoxForm: selectors.addBoxForm,
});

const mapDispatchToProps = (dispatch, props) => ({
    setHardwareSerial: (serial) => dispatch(actions.setHardwareSerialNumber(serial, isBoxSerialValidOrEmpty(serial))),
    getHardwareBySerial: (serial) => dispatch(actions.getHardwareBySerial(serial)),    
});

export default connect(mapStateToProps, mapDispatchToProps)(BoxInput)